import React from 'react';
import { connect } from 'react-redux';
import WorkBillConfirm from '../../components/templates/WorkBillConfirm';
import { commonOperations } from '../../reducks/common';
import { workOperations } from '../../reducks/work';

const mapStateToProps = state => ({
  currentTheme: state.style.theme,
  auth: state.auth,
  applyDetail: state.work.applyDetail
});

const mapDispatchToProps = {
  doOpenDialog: commonOperations.doOpenDialog,
  doApplyConsentBillOperation: workOperations.doApplyConsentBillOperation,
};

class App extends React.Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (<WorkBillConfirm
      {...this.props}
    />);
  }
}

const ContainerApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default ContainerApp;
